<template>
  <div class="row">
    <el-dialog
      left
      title="Send Email"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      width="400px"
      @close="handleCancel()"
      style="margin: 0 auto;"
      :visible.sync="isShow"
      class="team-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <form @submit.prevent="sendEmail">
        <div
          class="emailInfoCls"
        >Total {{this.value.data.emails && this.value.data.emails.length?this.value.data.emails.length:0}} members selected</div>
        <div class="row">
          <div class="col-12">
            <div>
              Subject
              <span class="required">*</span>
            </div>
            <input
              type="text"
              class="form-control team-form"
              v-model="value.data.subject"
              required
              placeholder="Subject"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div>
              Body
              <span class="required">*</span>
            </div>
            <textarea
              rows="5"
              cols="50"
              class="form-control"
              required
              spellcheck="false"
              placeholder="Body"
              v-model="value.data.body"
            ></textarea>
          </div>
        </div>
        <div class="row m-0">
          <div
            class="col-4 attach-class pl-0 pr-0"
            style="padding-top: 7px;font-size: 12px;"
            @click="$refs.fileBtn.click();"
          >
            <i class="fa fa-paperclip" aria-hidden="true"></i>
            Attach a file
            <input
              type="file"
              ref="fileBtn"
              id="fileId"
              @change="handleFile"
              class="hidden"
            />
          </div>
          <div
            class="col-8 drag-drop-class"
            style="padding-top: 6px;"
            v-cloak
            @drop.prevent="addFile"
            @dragover.prevent
          >Drag and drop file to attach</div>
        </div>
        <div class="mt-3">
          <div v-if="files.add">
            <div v-for="(item,index) in files.add" :key="index" class="d-flex fileItem my-2">
              <i
                v-if="item.type.includes('.doc') || item.name.includes('.doc') || item.name.includes('.txt')"
                class="fas fa-file-word mr-2 mt-1"
                style="color:#5190FF"
              ></i>
              <i
                v-else-if="item.type.includes('zip') || item.name.includes('.zip') || item.type.includes('rar') || item.name.includes('.rar')"
                class="far fa-file-archive mr-2 mt-1"
              ></i>
              <i v-else-if="item.type.includes('image')" class="fas fa-image mr-2"></i>
              <i
                v-else-if="item.type.includes('csv') || item.type.includes('xls') || item.name.includes('.csv') || item.name.includes('.xls')"
                class="fas fa-file-excel mr-2 mt-1"
                style="color:#F15643"
              ></i>
              <i
                v-else-if="item.type.includes('pdf') || item.type.includes('.pdf')"
                class="fas fa-file-pdf mr-2 mt-1"
                style="color:#F15643"
              ></i>
              <span
                class="attachment-name-class"
                @click="handleDownload(item,'file')"
                style="cursor:pointer"
              >{{item.name}}</span>
              <i
                class="fas fa-times"
                @click="deleteFile(index,'add')"
                style="float: right;padding-top: 5px;margin-right: 18px;cursor:pointer"
              ></i>
            </div>
          </div>
        </div>
        <div class="edit-company-action-button-row py-3" style="margin:0px">
          <button
            type="button"
            class="todo-form-cancel-button btn-outline-secondary"
            @click.prevent="handleCancel()"
          >Cancel</button>
          <button
            type="submit"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px;"
            :disabled="submitted"
          >
            Send
            <b-spinner v-if="submitted" style="float: right;" small label="Loading..."></b-spinner>
          </button>
        </div>
      </form>
    </el-dialog>
  </div>
</template>
<script>
import { Select, Option, Dialog } from "element-ui";
import api from "../../../axios_api";
export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog
  },
  computed: {
    isShow: {
      get() {
        if (this.value.isShow) {
          this.files = {
            add: [],
            update: [],
            delete: []
          };
        }
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
      }
    }
  },
  props: {
    value: {
      isShow: Boolean,
      data: Object
    }
  },
  data() {
    return {
      submitted: false,
      files: {
        add: [],
        update: [],
        delete: []
      }
    };
  },
  methods: {
    sendEmail() {
      let self = this;
      if (this.value.data.emails && this.value.data.emails.length <= 0) {
        this.$toaster.error("Please provide atleast One Email.");
        this.handleCancel();
        return;
      }
      this.submitted = true;
      let formData = new FormData();
      let payload = {};
      payload.subject = this.value.data.subject.trim();
      payload.body = this.value.data.body.trim();
      payload.emails = this.value.data.emails;
      if (this.files.add && this.files.add.length) {
        payload.files = this.files.add;
        for (var i = 0; i < payload.files.length; i++) {
          let file = payload.files[i];

          if (!file) {
            file = new Blob(["test"], { type: "text/plain;charset=utf-8" });
          }

          formData.append("files[" + i + "]", file, file ? file.name : "");
        }
      }
      formData.append(
        "encrypt",
        JSON.stringify({ encrypt: { data: payload } })
      );
      api
        .post(`/${this.$route.params.account_id}/bulk-team-mails`, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(res => {
          self.$emit("emit-sucess");
          self.$toaster.success("Email(s) will be sent shortly.");
          this.handleCancel();
        })
        .catch(err => {
          this.$toaster.error("Fail to send Email..please try again.");
          this.submitted = false;
        });
    },
    handleCancel() {
      this.submitted = false;
      this.value.isShow = false;
      this.files = {
        add: [],
        update: [],
        delete: []
      };
    },
    deleteFile(index, type) {
      if (type == "add") this.files.add.splice(index, 1);
      else {
        let data = this.files.update.splice(index, 1);
        this.files.delete.push(data[0]);
      }
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      [...droppedFiles].forEach(f => {
        this.files.add.push(f);
      });
    },
    handleFile(e) {
      let droppedFiles = e.target.files;
      if (!droppedFiles) return;
      [...droppedFiles].forEach(f => {
        this.files.add.push(f);
      });
    }
  }
};
</script>
<style>
.emailInfoCls {
  background: #f3f2fc 0% 0% no-repeat padding-box;
  border-radius: 4px;
  margin-bottom: 15px;
  padding: 10px;
  font-size: 13px;
  line-height: 15px;
  color: #4a4a4a;
}
</style>
    